import './index.less';
import React from 'react';
import { Message } from 'antd';
import { getCode } from '../../api/index.js';
import { checkMobile } from '../../plugins/utils.js';

class CodeBtn extends React.Component {

  constructor() {
    super();
    this.state = {
      codeTip: '获取验证码',
      timeCount: 60,
    }
  }

  getcode = () => {
		const { mobile, type } = this.props;
    if (!checkMobile(mobile)) {
      return;
    }
    getCode({
    	mobile: mobile,
    	type: type
    }).then(res => {
    	if (res.code === 200) {
        this.interval = setInterval(() => {
          var timer = this.state.timeCount - 1
          if(timer === 0){
            this.interval && clearInterval(this.interval);
            this.setState({
              codeTip: '获取验证码',
              timeCount: 60,
            })
          } else {
            this.setState({
              codeTip: '重新获取(' + timer + 's)',
              timeCount: timer
            })
          }
        }, 1000)
        Message.success(res.output);
        return
      }
      Message.error(res.tip);
    })
  }

  componentWillUnmount(){
    clearInterval(this.interval);
  }

  render() {
  	const { codeTip, timeCount } = this.state;
    return (
      <div className='code'>
        {
          timeCount === 60 ? <div className='code-getcode' onClick={() => this.getcode()}>获取验证码</div> : <div className='code-getcode code-disabled'>{codeTip}</div>
        }
      </div>
    );
  }
}

export default CodeBtn;



// WEBPACK FOOTER //
// ./src/components/codeBtn/codeBtn.jsx